var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRili(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.958 7.182h10.084M3 14h10a.5.5 0 00.5-.5v-9A.5.5 0 0013 4H3a.5.5 0 00-.5.5v9a.5.5 0 00.5.5z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5V5M10.5 2.5V5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuOTU4MzMgNy4xODE4MkgxMy4wNDE3TTMgMTRIMTNDMTMuMjc2MSAxNCAxMy41IDEzLjc3NjEgMTMuNSAxMy41VjQuNUMxMy41IDQuMjIzODYgMTMuMjc2MSA0IDEzIDRIM0MyLjcyMzg2IDQgMi41IDQuMjIzODYgMi41IDQuNVYxMy41QzIuNSAxMy43NzYxIDIuNzIzODYgMTQgMyAxNFoiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNNS41IDIuNVY1IiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuNSAyLjVWNSIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgTongyongRili as ReactComponent };